import { Outlet } from "react-router-dom"
const MainProject = () =>{

    return(
        <div className=" w-full h-full">
         <Outlet/>
        </div>
    )
}


export default MainProject;